import React, { useState } from 'react';
import { HiOutlineDotsVertical, HiX } from 'react-icons/hi';
import '../styles/HeaderSurat.css';

const HeaderSurat = ({ surah, handleMenuClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isIconClicked, setIsIconClicked] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsIconClicked(!isIconClicked);
  };

  return (
    <div className='header-surat'>
      <div className='menu-wrapper'>
        <div className='menu' onClick={handleMenuToggle}>
          {isIconClicked ? (
            <HiX className='menu-icon-clicked' />
          ) : (
            <HiOutlineDotsVertical className='menu-icon' />
          )}
        </div>
        {isMenuOpen && (
          <div className='menu-items'>
            <div className='menu-item ' onClick={() => handleMenuClick('Cari')}>
              Cari
            </div>
            <div
              className='menu-item '
              onClick={() => handleMenuClick('Murojaah')}
            >
              Murojaah
            </div>
            <div
              className='menu-item '
              onClick={() => handleMenuClick('Audio')}
            >
              Audio
            </div>
            <div
              className='menu-item '
              onClick={() => handleMenuClick('Setting')}
            >
              Setting
            </div>
          </div>
        )}
      </div>
      <p className='arab-nama'> السورة {surah.nama} </p>
      <p className='latin latin-surah'>Surah {surah.namaLatin}</p>
      <div className='line'></div>
      <p className='latin latin-detail'>
        {surah.tempatTurun} - {surah.arti} - {surah.jumlahAyat} ayat
      </p>
      <p className='arab-basmalah'>بِسْمِ اللهِ الرَّحْمَنِ الرَّحِيْمِ</p>
    </div>
  );
};

export default HeaderSurat;
